module.exports = __webpack_public_path__ + "img/fatura.cbda92df.svg";